// =============================================================================
// EventBus event registry
// =============================================================================
//
// Single source of truth for cross-component signals. The bus is for
// "decoupled parts of the page reacting to a shared moment" — not a data store
// (see src/js/README.md). One name per event, grouped by domain, payload shape
// documented inline so consumers know what they receive.
//
// Add a constant here BEFORE emitting/listening to a new event: in debug mode
// the bus warns on any name not found in this registry (see smpl-components.js
// `_assertKnown`).

export const Events = Object.freeze({
	// Page lifecycle
	PAGE_RESIZE: 'page:resize', // payload: {} — debounced viewport change
	PAGE_READY: 'page:ready', // payload: visit — fired after a Swup page:view settles

	// Swup navigation
	SWUP_CONTENT_REPLACE: 'swup:content:replace', // payload: {} — new DOM in place after a swap
	SWUP_PAGE_VIEW: 'swup:page:view', // payload: visit — Swup page:view hook

	// ScrollTrigger
	SCROLLTRIGGER_CREATED: 'scrolltrigger:created', // payload: instance — framework hook point (no default listener)

	// Cart
	CART_UPDATED: 'cart:updated', // payload: { fragments, cartHash } — after a successful AJAX add to cart

	// Filters
	FILTERS_CLEAR: 'filters:clear', // payload: {} — request to reset all active filters
})
